export interface GuaCard {
  id: string;
  cat: string;
  target: string;
  title: string;
  digest: string;
  time: string;
  views: string;
  reply: string;
  badge: string;
  badgeTone: string;
}

export interface PreviewItem {
  id: string;
  target: string;
  title: string;
  digest: string;
  eta: string;
  clue: string;
  img: string;
}

export const navLinks = [
  { href: "#hot", label: "实时热榜" },
  { href: "#category", label: "分类瓜田" },
  { href: "#feed", label: "最新跟进" },
  { href: "#reversal", label: "反转追踪" },
  { href: "#coming", label: "下回分解" },
  { href: "#about", label: "关于我们" },
];

export const tickerItems = [
  "S姓选秀C位退团悬念今日迎来官方回应，剧情再度反转",
  "带货一哥老K退款风波进入第三轮，平台开始介入跟进",
  "W姓顶流男歌手合约门出现新证据，疑似口头续约曝光",
  "T姓综艺常驻MC去留未定，节目组深夜发文留悬念",
  "G姓网红情侣分手声明后同框被拍，复合疑云再起",
];

export const categoryTabs = [
  { key: "all", label: "全部看瓜" },
  { key: "follow", label: "后续跟进" },
  { key: "reverse", label: "反转疑云" },
  { key: "progress", label: "最新进展" },
  { key: "result", label: "实锤结果" },
  { key: "tease", label: "下回分解" },
];

export const categoryIntro = {
  follow: { title: "后续跟进", color: "text-primary-600", bg: "bg-primary-100/70", icon: "ri-refresh-line" },
  reverse: { title: "反转疑云", color: "text-secondary-600", bg: "bg-secondary-100/80", icon: "ri-loop-left-line" },
  progress: { title: "最新进展", color: "text-accent-700", bg: "bg-accent-100/70", icon: "ri-bar-chart-2-line" },
  result: { title: "实锤结果", color: "text-foreground-800", bg: "bg-background-200", icon: "ri-check-double-line" },
  tease: { title: "下回分解", color: "text-foreground-800", bg: "bg-background-200", icon: "ri-more-2-fill" },
};

export const hotTrends = [
  { rank: 1, target: "带货一哥老K", title: "退款风波第三轮：平台介入，涉事选品名单进一步扩大", tag: "最新进展", delta: "+218%", tone: "text-primary-500", up: true },
  { rank: 2, target: "S姓选秀C位", title: "退团悬念反转：深夜声明称将成立个人工作室", tag: "反转疑云", delta: "+174%", tone: "text-secondary-500", up: true },
  { rank: 3, target: "W姓顶流男歌手", title: "合约门曝出新录音，经纪公司两小时后急辟谣", tag: "后续跟进", delta: "+131%", tone: "text-primary-500", up: true },
  { rank: 4, target: "T姓综艺常驻", title: "去留悬念坐实：节目组官宣阵容，MC并未换人", tag: "实锤结果", delta: "+96%", tone: "text-accent-600", up: true },
  { rank: 5, target: "M姓悬疑剧导演", title: "抄袭争议迎来第三方鉴定，官方回应下周公布", tag: "最新进展", delta: "+74%", tone: "text-secondary-500", up: true },
  { rank: 6, target: "G姓网红情侣", title: "分手后又同框，被拍到共同出入机场，复合疑云升级", tag: "反转疑云", delta: "+52%", tone: "text-primary-500", up: true },
  { rank: 7, target: "Z姓退圈女演员", title: "复出传闻持续发酵，新剧备案信息被网友扒出", tag: "下回分解", delta: "+39%", tone: "text-foreground-700", up: true },
  { rank: 8, target: "C姓新生代小花", title: "红毯事件后续：造型团队发文致歉并回应细节", tag: "实锤结果", delta: "+27%", tone: "text-foreground-700", up: true },
];

export const guaCards: GuaCard[] = [
  {
    id: "g1", cat: "reverse", target: "S姓选秀C位", badgeTone: "text-secondary-700 bg-secondary-100",
    title: "退团悬念深夜反转：本人发声将单飞成立个人工作室",
    digest: "从组合公告「暂时休整」到经纪公司深夜删文，再到本人疑似小号发声，这颗瓜的后续在 24 小时内连续反转两次。我们将各方时间线逐一核对后给出最新进展。",
    time: "今日 09:40", views: "128万", reply: "3.2万", badge: "反转",
  },
  {
    id: "g2", cat: "follow", target: "W姓顶流男歌手", badgeTone: "text-primary-600 bg-primary-100",
    title: "合约门跟进：疑似口头续约录音流出，双方口径仍不一致",
    digest: "「到期不续」的说法遭遇挑战。我们持续跟进双方官宣与外媒爆料，整理出这轮争辩中真正站得住脚的三处关键证据。",
    time: "今日 08:15", views: "96万", reply: "1.9万", badge: "跟进",
  },
  {
    id: "g3", cat: "progress", target: "带货一哥老K", badgeTone: "text-accent-700 bg-accent-100",
    title: "退款风波最新进展：平台公布第三批退换货与补偿细则",
    digest: "平台今早更新处置说明，把退款范围、到账时间与售后入口一次性说清。我们逐条解读，帮你判断到底哪些订单能退、怎么退。",
    time: "今日 07:30", views: "210万", reply: "4.6万", badge: "进展",
  },
  {
    id: "g4", cat: "result", target: "T姓综艺常驻", badgeTone: "text-foreground-800 bg-background-200",
    title: "去留悬念坐实：节目组官宣新一季阵容，MC顺利留任",
    digest: "争论了快一个月的「换人传闻」迎来结局。官方一纸声明让此前所有捕风捉影的下回分解都有了明确答案，我们复盘整条脉络。",
    time: "昨日 22:05", views: "54万", reply: "8千", badge: "实锤",
  },
  {
    id: "g5", cat: "tease", target: "Z姓退圈女演员", badgeTone: "text-foreground-800 bg-background-200",
    title: "复出传闻下回分解：新剧备案信息被扒，导演人选成焦点",
    digest: "退圈多年后首度「有戏」，网友从备案信息顺藤摸瓜出班底名单。是彻底复出还是客串捧场？本瓜仍在发酵，静待最新进展。",
    time: "昨日 20:30", views: "78万", reply: "1.1万", badge: "悬念",
  },
  {
    id: "g6", cat: "reverse", target: "G姓网红情侣", badgeTone: "text-secondary-700 bg-secondary-100",
    title: "分手声明后又反转：机场同框照流出，复合疑云再起",
    digest: "昨天还官宣「和平分手」，今天就同框现身。究竟是复合、单纯同行还是团队炒作？我们对比两段声明与现场细节，给出一版可读的跟进。",
    time: "昨日 18:12", views: "143万", reply: "2.8万", badge: "反转",
  },
  {
    id: "g7", cat: "follow", target: "M姓悬疑剧导演", badgeTone: "text-primary-600 bg-primary-100",
    title: "抄袭争议跟进：第三方鉴定已启动，比对报告下周出炉",
    digest: "剧集高开低走，抄袭指控愈演愈烈。片方终于松口委托独立机构鉴定，我们同步跟踪鉴定范围与抽帧取样标准。",
    time: "昨日 16:40", views: "67万", reply: "6千", badge: "跟进",
  },
  {
    id: "g8", cat: "result", target: "C姓新生代小花", badgeTone: "text-foreground-800 bg-background-200",
    title: "红毯事件结果落地：造型团队道歉并补发高清精修图",
    digest: "一场造型争议以公开致歉收场。我们整理了事件始末与最终结果，厘清「谁的责任」与「给谁的交代」两个核心问题。",
    time: "昨日 14:08", views: "45万", reply: "4千", badge: "结果",
  },
  {
    id: "g9", cat: "progress", target: "W姓顶流男歌手", badgeTone: "text-accent-700 bg-accent-100",
    title: "合约门最新进展：粉丝晒票根质疑「告别演唱会」真实性",
    digest: "一边传出告别场消息，一边又迟迟未官宣档期。粉丝晒出的票根与场地排期冲突，让这场「告别」变成新的罗生门。",
    time: "今日 06:20", views: "89万", reply: "1.5万", badge: "进展",
  },
];

export const reversalTimeline = {
  target: "S姓选秀C位退团悬念",
  lead: "48 小时内连翻三次的瓜，我们把每一条关键动态按时间排好。真正的下回分解，往往藏在细节里。",
  cover:
    "https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20a%20backstage%20stage%20spotlight%20with%20silhouette%20of%20a%20young%20singer%2C%20warm%20coral%20and%20green%20stage%20lights%2C%20dramatic%20atmosphere%2C%20clean%20modern%20graphic%20style&width=1200&height=760&seq=gua-timeline-2026&orientation=landscape",
  steps: [
    {
      tag: "后续", time: "第1天 晚间", title: "组合官博突发文：成员因「个人安排」暂时休整",
      desc: "没有具体原因、没有时长说明的一则公告，迅速登上热搜。组合粉与个人粉开始互相指责，争议的第一条线就此埋下。",
      solid: true,
    },
    {
      tag: "反转", time: "第2天 凌晨", title: "经纪公司深夜删文，删除的公告成了新话题",
      desc: "发布后不到五小时，原公告被悄悄删除。删文动作本身，让「休整」变成「疑似解约」，猜测进一步升温。",
      solid: true,
    },
    {
      tag: "最新进展", time: "第2天 上午", title: "成员疑似小号发声：「想换一种方式继续」",
      desc: "一个声称本人运营的账号发布长文，用词暧昧。虽无法完全证实身份，却让「单飞」成为全网最主流的一种推测。",
      solid: true,
    },
    {
      tag: "反转", time: "第2天 深夜", title: "官方正式回应成立个人工作室，剧情再翻转",
      desc: "在万众期待中，官方终于下场：确认该成员将以个人身份运营，未来仍与组合保持合作。第三次反转就此坐实。",
      solid: false,
    },
  ],
};

export const comingNext: PreviewItem[] = [
  {
    id: "c1", target: "Z姓退圈女演员",
    title: "新剧班底若官宣，复出将是板上钉钉",
    digest: "备案信息里的男主与导演人选都在摇摆，一旦下周放出首轮官宣照，「复出」便从传闻变成结果。",
    eta: "预计 3 天内", clue: "制片人关注列表出现新变化", img: "https://readdy.ai/api/search-image?query=Warm%20film%20studio%20clapperboard%20and%20casting%20documents%20on%20wooden%20desk%2C%20editorial%20illustration%2C%20coral%20and%20cream%20tone%2C%20soft%20light&width=640&height=420&seq=gua-prev-01&orientation=landscape",
  },
  {
    id: "c2", target: "带货一哥老K",
    title: "平台细则若落地，退款范围将再次扩大",
    digest: "业内消息称售后清单还会追加第四批商品，粉丝群体也在等待主播本人的「再发声」。",
    eta: "预计 1 天内", clue: "售后页悄然更新了 FAQ 目录", img: "https://readdy.ai/api/search-image?query=Modern%20refund%20and%20returns%20concept%20illustration%20with%20shopping%20bags%20and%20documents%2C%20fresh%20green%20and%20cream%20editorial%20style&width=640&height=420&seq=gua-prev-02&orientation=landscape",
  },
  {
    id: "c3", target: "G姓网红情侣",
    title: "同框之后，是复合声明还是各自辟谣",
    digest: "双方团队至今未就同框发声，而粉丝已从同款手机壳挖出「复合实锤」。下一步回应，决定这颗瓜的最终走向。",
    eta: "预计 48 小时内", clue: "两条视频评论区疑似相互串门", img: "https://readdy.ai/api/search-image?query=Two%20phones%20showing%20hearts%20and%20chat%20bubbles%20over%20soft%20sunset%20backdrop%2C%20playful%20editorial%20illustration%2C%20warm%20coral%20tone&width=640&height=420&seq=gua-prev-03&orientation=landscape",
  },
];

export const faqs = [
  {
    q: "「每日有瓜」具体追踪什么样的瓜？",
    a: "我们专注整理娱乐与泛社会热点中的「后续、反转与最新进展」。当一件事件成为大家口中的瓜，我们会持续跟进它的每一次更新，帮助你在碎片信息里快速拼出完整剧情，而不是看完了开头就没了下文。",
  },
  {
    q: "如何查看某颗瓜的完整时间线和下回分解？",
    a: "进入「反转追踪」与「下回分解」板块即可看到分阶段整理的脉络。每颗仍在发酵的瓜，我们都会标注当前所处阶段、已实锤的结果与尚未落地的悬念，方便你随时回来追更。",
  },
  {
    q: "网站上的反转与结果信息可信吗？",
    a: "我们坚持「信息来源优先」原则：正文会标注动态来源与发生时间，区分「官方确认」与「网络传言」。凡未获官方或一手信息证实的说法，我们一律标注为传闻，并在最新进展中持续修正。",
  },
  {
    q: "为什么我的账号会看到与其他网友不同的热度排序？",
    a: "实时热榜综合了浏览量、互动量与更新新鲜度进行加权排序，会随最新动态实时变化。同一颗瓜在不同时段的热度排名可能不同，这正是「跟进」的意义所在。",
  },
  {
    q: "如何第一时间收到某颗瓜的最新进展提醒？",
    a: "你可以在文章页订阅感兴趣的主题，或在页面底部留下邮箱订阅「每日瓜报」。一旦你关注的瓜出现反转、结果或新进展，我们会在每日推送中优先提醒你。",
  },
  {
    q: "我也可以投稿提供线索吗？",
    a: "可以。欢迎通过底部邮箱把你觉得值得被跟进的线索发给我们。采纳后会由编辑团队核实，并在文章中按规则标注线索来源，投稿不收取任何费用。",
  },
];

export const voices = [
  { name: "夜猫子同学", role: "追更 S姓C位 全季", text: "从公告到删文到工作室，全程一条不漏。这里把反转整理得比我自己翻评论快多了。" },
  { name: "柚子不苦", role: "带货退款当事人", text: "退款细则写得明明白白，照着操作真的退了，跟进很靠谱。" },
  { name: "老牌剧迷", role: "常驻用户三年", text: "不喜欢标题党，这里的「进展」和「结果」分得很清楚，看着踏实。" },
  { name: "路过的企鹅", role: "刚入坑的新人", text: "第一次来，时间线一图看懂，下回分解的悬念也列得明明白白，收藏了。" },
];

export const footerColumns = [
  {
    title: "看瓜导航",
    links: [
      { label: "实时热榜", href: "#hot" },
      { label: "分类瓜田", href: "#category" },
      { label: "最新跟进", href: "#feed" },
      { label: "反转追踪", href: "#reversal" },
    ],
  },
  {
    title: "内容栏目",
    links: [
      { label: "下回分解", href: "#coming" },
      { label: "实锤结果", href: "#category" },
      { label: "用户口碑", href: "#about" },
      { label: "常见问题", href: "#faq" },
    ],
  },
  {
    title: "关于站点",
    links: [
      { label: "关于我们", href: "#about" },
      { label: "订阅瓜报", href: "#subscribe" },
      { label: "投稿线索", href: "#contact" },
      { label: "返回顶部", href: "#top" },
    ],
  },
];

export const stats = [
  { num: "2,400+", label: "追踪中的瓜" },
  { num: "680+", label: "反转实锤复盘" },
  { num: "38 万", label: "每日看瓜人次" },
  { num: "99.2%", label: "跟进准确率" },
];